/**
 * 비회원 위시리스트 클릭 제어 및 버튼 동작 보정
 * 비회원이 클릭 시 앱 동작을 차단하고 로그인 페이지로 강제 리다이렉트하며 폼 제출 충돌 및 아이콘 상태를 동기화합니다.
 */
(function () {
  // 비로그인 시 위시리스트 버튼 클릭 가로채기 (캡처 단계)
  document.addEventListener(
    'click',
    function (e) {
      const btn = e.target.closest('.bh-wishlist-button');
      if (!btn) return;

      const slot = btn.closest('.product-form-buttons__wishlist-slot');
      if (slot && slot.getAttribute('data-guest') === 'true') {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();

        const currentUrl = window.location.pathname + window.location.search;
        let cleanUrl = currentUrl;
        try {
          // 브라우저에 따라 이미 %인코딩된 값이 넘어오는 경우를 대비해 한 번 완전히 풀어줍니다.
          cleanUrl = decodeURIComponent(currentUrl); 
        } catch (e) {}

        // encodeURIComponent 대신 encodeURI를 사용하면 슬래시(/)가 %2F로 변환되는 것을 방지하여
        // Shopify의 return_to 보안 필터 및 인식률을 높이고 올바르게 리다이렉션 되로록 합니다.
        const returnPath = encodeURI(cleanUrl);

        window.location.href = '/account/login?return_to=' + returnPath + '&only_signin=true';
      }
    },
    true
  );

  function ensureWishlistButtonsDoNotSubmitForm(root) {
    const scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('.product-form-buttons__wishlist-slot button').forEach((btn) => {
      btn.type = 'button';
    });
  }

  function syncOneButton(btn) {
    if (!btn || !btn.classList || !btn.classList.contains('bh-wishlist-button')) return;
    const oc = btn.getAttribute('onclick') || '';
    if (oc.includes('addToWishlist_bh')) {
      btn.setAttribute('data-bh-wishlist', 'add');
    } else if (oc.includes('removeFromWishlist')) {
      btn.setAttribute('data-bh-wishlist', 'remove');
    } else {
      btn.removeAttribute('data-bh-wishlist');
    }
  }

  function syncBhWishlistButtonState(root) {
    const scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('.bh-wishlist-button').forEach((btn) => {
      syncOneButton(btn);
    });
  }

  /** 로딩 직전 onclick 과 달라질 때까지 아이콘 표시 지연(스피너 → 옛 아이콘 → 새 아이콘 깜빡임 완화) */
  function awaitUntilOnclickChanges(btn, snapshot) {
    const snap = snapshot == null ? '' : String(snapshot);
    btn.setAttribute('data-bh-await-icon', '');
    let frames = 0;
    const maxFrames = 90;

    function step() {
      const oc = btn.getAttribute('onclick') || '';
      if (oc !== snap) {
        btn.removeAttribute('data-bh-await-icon');
        syncOneButton(btn);
        return;
      }
      frames += 1;
      if (frames >= maxFrames) {
        btn.removeAttribute('data-bh-await-icon');
        syncOneButton(btn);
        return;
      }
      requestAnimationFrame(step);
    }

    requestAnimationFrame(step);
  }

  function run() {
    ensureWishlistButtonsDoNotSubmitForm(document);
    syncBhWishlistButtonState(document);
  }

  let t = null;
  function scheduleDebouncedRun() {
    clearTimeout(t);
    t = setTimeout(run, 50);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  const mo = new MutationObserver((mutations) => {
    let needDebounced = false;

    for (let i = 0; i < mutations.length; i += 1) {
      const m = mutations[i];

      if (m.type === 'attributes' && m.target && m.target.classList && m.target.classList.contains('bh-wishlist-button')) {
        const el = m.target;

        if (m.attributeName === 'onclick') {
          syncOneButton(el);
          continue;
        }

        if (m.attributeName === 'class') {
          const oldVal = m.oldValue || '';
          const hadLoader = /\bbh_button_loader\b/.test(oldVal);
          const hasLoader = el.classList.contains('bh_button_loader');

          if (!hadLoader && hasLoader) {
            el.dataset.bhOnclickBeforeLoad = el.getAttribute('onclick') || '';
          } else if (hadLoader && !hasLoader) {
            const snap = el.dataset.bhOnclickBeforeLoad;
            delete el.dataset.bhOnclickBeforeLoad;
            if (snap !== undefined) {
              awaitUntilOnclickChanges(el, snap);
            } else {
              syncOneButton(el);
            }
          }
          continue;
        }
      }

      needDebounced = true;
    }

    if (needDebounced) {
      scheduleDebouncedRun();
    }
  });

  mo.observe(document.documentElement, {
    childList: true,
    subtree: true,
    characterData: true,
    attributes: true,
    attributeOldValue: true,
    attributeFilter: ['onclick', 'class'],
  });
})();
